<template>
  <div id="management-queue" class="table-section">
    <el-table :data="manageAutoQueue.records" :header-row-style="headerRowStyle" max-height="550px" border
      highlight-current-row>
      <el-table-column prop="borrowerId" label="用户编号" width="70">
        <template slot-scope="scope">
          <router-link
            :to="{ name: 'taskDetail', params: { loanId: scope.row.loanId, taskId: scope.row.id, status: 'C-M1' } }">{{
      scope.row.borrowerId }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="borrowerName" label="用户姓名" width="70" />
      <el-table-column prop="overdueDate" label="逾期日期" />
      <el-table-column prop="penaltyDay" label="逾期天数" width="70" />
      <el-table-column prop="productType" label="产品类别" />
      <el-table-column prop="amount" label="应还未还款" />
      <el-table-column prop="lastCallTime" label="最近跟进时间" />
      <el-table-column prop="lastCallAgent" label="处理人" />
    </el-table>
    <div class="pagination-section">
      <el-pagination :page-size="pageSize" :total="manageAutoQueueTasksList" :page-sizes="[5, 10, 15, 20]"
        layout="total, sizes, prev, pager, next" @current-change="changePage" @size-change="changeSize" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'manage-auto-queue',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      pageSize: 5,
      page: 0
    }
  },
  computed: {
    ...mapGetters([
      'manageAutoQueue',
      'manageAutoQueueTasksList'
    ])
  },
  created() {
    this.getAutoQueue({ page: this.page, size: this.pageSize })
  },
  methods: {
    ...mapActions([
      'getAutoQueue'
    ]),
    changePage(currentPage) {
      this.page = currentPage
      this.getAutoQueue({ page: this.page, size: this.pageSize })
    },
    changeSize(currentSize) {
      this.pageSize = currentSize
      this.page = 0
      this.getAutoQueue({ page: this.page, size: this.pageSize })
    }
  }
}
</script>

<style lang="scss" scoped></style>
